import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { SYMPTOMS } from "../data/site";

export default function SymptomSearch({ headingTag: Tag = "h2" }) {
  return (
    <section
      id="symptoms"
      data-testid="symptom-search-section"
      className="section-pad"
    >
      <div className="container-x">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div className="max-w-2xl">
            <div className="overline">Start with a symptom</div>
            <Tag className="font-serif-display mt-4 text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05]">
              Search Gastro &amp; Liver Symptoms in Varanasi.
            </Tag>
          </div>
          <p className="text-black/65 max-w-sm text-[15px] leading-relaxed">
            Most people don&apos;t know the disease — they know the symptom.
            Pick the closest match. Each leads to a focused, doctor-written
            guide and an option to consult.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-black/10 border border-black/10 rounded-[6px] overflow-hidden">
          {SYMPTOMS.map((s, i) => (
            <Link
              key={s.slug}
              to={`/symptoms/${s.slug}`}
              data-testid={`symptom-card-${s.slug}`}
              className="group relative bg-white p-7 md:p-8 flex flex-col gap-4 min-h-[220px] hover:bg-[#EAF6FD] transition-colors"
            >
              <div className="flex items-center justify-between">
                <span className="text-[10px] tracking-[0.22em] uppercase text-[#0370AD] font-semibold">
                  {String(i + 1).padStart(2, "0")} / {s.tag}
                </span>
                <ArrowUpRight className="h-4 w-4 arrow text-black/40 group-hover:text-[#0370AD]" />
              </div>
              <div className="mt-auto">
                <h3 className="font-display-semibold text-2xl md:text-[26px] leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-[13.5px] text-black/65 leading-relaxed">
                  {s.blurb}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
